<template>
  <div class="website-bd tb" v-if="funcView.device_receipt_record_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item v-if="funcView.device_receipt_record_edit">
          <el-button type="primary" @click="editOrder">{{ funcView.device_receipt_record_edit }}</el-button>
        </el-form-item>
        <!-- 导出 -->
        <el-form-item style="float: right; margin-right: 0">
          <el-dropdown>
            <el-button class="table-set" style="vertical-align: top"
              @click.native="exportTable('orderDeliveryMonthExport', formSearch)"><i class="icon icon-daochu"></i></el-button>
          </el-dropdown>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.consigneeOrgName"
            :placeholder="$t('crm_deviceReceiptRecord.shou_huo_gong_si')"
            @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <custom-date-picker style="width: 100%" value-format="yyyy-MM" v-model="formSearch.gmtModified"
            type="monthrange" :start-placeholder="$t('crm_deviceReceiptRecord.kai_shi_yue_fen')"
            :end-placeholder="$t('crm_deviceReceiptRecord.jie_shu_yue_fen')"
            :picker-options="{'firstDayOfWeek': 1}"
            @change="onPageChange({ page: 1 })"
            ></custom-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table height="100%" :data="tableList" :column="tableColumn" @filter="filterChange" @sort="sortChange"
        :slots="['receiptOrder', 'shipmentMonth', 'action']">
        <template v-slot:shipmentMonth="scope">
          <span>
            <div v-if="funcView.device_receipt_record_check_order" class="cell-link" @click="checkOrder(scope.row)">{{
              scope.row.shipmentMonth }}</div>
            <span v-else>{{ scope.row.shipmentMonth }}</span>
          </span>
        </template>
        <!-- 查看，显示逻辑：待确认，已完成 -->
        <template v-slot:receiptOrder="scope">
          <el-button v-if="checkImgVisible(scope.row) && funcView.device_receipt_record_check" type="text" size="mini"
            @click="checkImg(scope.row)">{{ funcView.device_receipt_record_check }}</el-button>
        </template>
        <template v-slot:action="scope">
          <!-- 打印： 实际都可以打印，只是待上传时，列表中才有一个方便使用的入口 -->
          <el-button v-if="onPrintVisible(scope.row) && funcView.device_receipt_record_print" type="text" size="mini"
            @click="onPrint(scope.row)">{{ funcView.device_receipt_record_print }}</el-button>
          <!-- 上传：显示逻辑：待上传 -->
          <el-button v-if="onUploadVisible(scope.row) && funcView.device_receipt_record_upload" type="text" size="mini"
            @click="onUpload(scope.row)">{{ funcView.device_receipt_record_upload }}</el-button>
          <!-- 重新上传：显示逻辑：待确认 -->
          <el-button v-if="reUploadVisible(scope.row) && funcView.device_receipt_record_reupload" type="text" size="mini"
            @click="onReupload(scope.row)">{{ funcView.device_receipt_record_reupload }}</el-button>
          <!-- 确认：显示逻辑：待确认 -->
          <el-button v-if="onConfirmVisible(scope.row) && funcView.device_receipt_record_confirm" type="text" size="mini"
            @click="onConfirm(scope.row)">{{ funcView.device_receipt_record_confirm }}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize"
        @change="onPageChange"></custom-page>
    </div>
    <upload-dialog v-if="uploadDialogVisible" @close="uploadDialogVisible = false" :model="uploadDialogModel"
      @success="onPageChange({ page: 1 })"></upload-dialog>
    <img-list-dialog v-if="imgListDialogVisible" @close="imgListDialogVisible = false"
      :model="imgListDialogModel"></img-list-dialog>
    <print-order-dialog v-if="printOrderVisible" @close="printOrderVisible = false" :model="printOrderModel"
      :printVisible="!!funcView.device_receipt_record_print"></print-order-dialog>
    <edit-device-dialog v-if="editOrderVisible" @close="editOrderVisible = false" :model="editOrderModel"
      @success="onPageChange({ page: 1 })"></edit-device-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins';
import uploadDialog from './children/upload_dialog';
import imgListDialog from './children/img_list_dialog.vue';
import printOrderDialog from './children/print_order_dialog.vue';
import editDeviceDialog from './children/edit_device_dialog.vue';

export default {
  name: 'deviceReceiptRecord',
  mixins: [resetFormSearchMixins],
  components: { uploadDialog, imgListDialog, printOrderDialog, editDeviceDialog },
  data() {
    return {
      tableCode: 'device_receipt_record',
      provide: true,
      formSearch: {
        // 收货公司
        consigneeOrgName: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
        gmtModified: '',


      },

      tableList: [],
      totalRows: 0,

      dialogVisible: false,
      dialogModel: {},
      // dialogData: {},

      dialogVisible1: false,
      dialogModel1: {},
      // dialogData1: {},

      uploadDialogVisible: false,
      uploadDialogModel: {},

      imgListDialogVisible: false,
      imgListDialogModel: {},

      //  确认签收单 - 打印
      printOrderVisible: false,
      printOrderModel: {},

      // 编辑签收单
      editOrderVisible: false,
      editOrderModel: {},

      link: null,
    };
  },
  mounted: function () {
    this.getTableColumn();
    this.getFuncView(null, () => {

    });

    this.getTableList();
  },
  methods: {
    // 确认
    onConfirm(row) {
      // 您确定要确认所选签收单，确定后将无法修改
      const tips = this.$t('crm_deviceReceiptRecord.nqdyqrsxqsdqdhjwfxg');
      const url = `${apis.orderDeliveryMonthConfirm}/${row.orderDeliveryMonthId}`;
      // orderDeliveryMonthConfirm
      this.$showConfirm(tips).then(() => {
        this.$postJSON(url).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.onPageChange({ page: 1 });
        });
      });
    },

    // 重新上传
    onReupload(row) {
      const tips = this.$t('crm_deviceReceiptRecord.nqdykhcxscm');
      const url = `${apis.orderDeliveryMonthRefuse}/${row.orderDeliveryMonthId}`;
      // orderDeliveryMonthConfirm
      this.$showConfirm(tips).then(() => {
        this.$postJSON(url).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.onPageChange({ page: 1 });
        });
      });
    },

    // 查看，显示逻辑：待确认，已完成
    checkImgVisible(row) {
      const { completeState } = row;
      const whiteList = ['1', '6'];
      return whiteList.includes(`${completeState}`);
    },
    // 打印：显示逻辑：待上传。（实际都可以打印，只是待上传时，列表中才有一个方便使用的入口）
    onPrintVisible(row) {
      const { completeState } = row;
      const whiteList = ['0'];
      return whiteList.includes(`${completeState}`);
    },
    onUploadVisible(row) {
      const { completeState } = row;
      const whiteList = ['0'];
      return whiteList.includes(`${completeState}`);
    },
    reUploadVisible(row) {
      const { completeState } = row;
      const whiteList = ['1'];
      return whiteList.includes(`${completeState}`);
    },
    onConfirmVisible(row) {
      const { completeState } = row;
      const whiteList = ['1'];
      return whiteList.includes(`${completeState}`);
    },
    // 编辑签收单
    editOrder() {
      this.editOrderModel = {
        title: this.$t('crm_deviceReceiptRecord.bian_ji_she_bei'),
      };
      this.editOrderVisible = true;
    },
    // 查看签收单
    checkOrder(row) {
      this.printOrderModel = {
        data: row,
      };
      this.printOrderVisible = true;
    },

    // 打印
    onPrint(row) {
      this.printOrderModel = {
        data: row,
        type: 'print'
      };
      this.printOrderVisible = true;
    },

    // 查看 - 图片
    checkImg(row) {
      this.imgListDialogModel = {
        title: this.$t('Common.com_detail'),
        data: row,
      };

      this.imgListDialogVisible = true;
    },
    onUpload(row) {
      this.uploadDialogModel = {
        title: this.$t('crm_deviceReceiptRecord.scooqsd', [row.shipmentMonth,row.consigneeOrgName]),
        data: row,
      };

      this.uploadDialogVisible = true;
    },
    getReqData() {
      // const timezone = this.formSearch.timezone.join('/');
      const ret = { ...this.formSearch };
      if (this.formSearch.gmtModified && this.formSearch.gmtModified.length) {
        ret.shipmentMonthStart = this.formSearch.gmtModified[0].replace('-', '');
        ret.shipmentMonthEnd = this.formSearch.gmtModified[1].replace('-', '');
        delete ret.gmtModified;
      }
      return ret;
    },
    // 获取表格数据
    getTableList: function () {
      this.$getJSON(apis.orderDeliveryMonthPage, this.getReqData()).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
};
</script>

<style lang="scss"></style>
